import type { TGlobalTopicListTab } from './global-topic-list-tab.types'
import { GlobalTopicsTableView } from '../global-topics-table'

export const GlobalTopicListTabView = ({
  data,
  error,
  handleSetOrder,
  hasMore,
  isFetchingMore,
  isLoading,
  refetch,
  totalCount,
  order,
  sentryRef,
}: TGlobalTopicListTab) => {
  return (
    <GlobalTopicsTableView
      data={data}
      error={error}
      handleSetOrder={handleSetOrder}
      hasMore={hasMore}
      isFetchingMore={isFetchingMore}
      isLoading={isLoading}
      refetch={refetch}
      totalCount={totalCount}
      order={order}
      sentryRef={sentryRef}
    />
  )
}
